"use strict";

import samlDisclaimerViewTemplate from "./SamlDisclaimerViewTemplate";

const SamlDisclaimerDirective = function (samlTokenService, $modal) {
    return {
        restrict: "E",
        template: samlDisclaimerViewTemplate,
        controller: [
            "$scope",
            "samlTokenService",
            function ($scope, samlTokenService) {
                $scope.continueClick = function () {
                    $scope.$parent.$close();
                    const ssoWindow = window.open("", "ssoWindow");
                    if ($scope.factoryname && $scope.factoryname !== "undefined") {
                        samlTokenService.navigateToken(
                            $scope.factoryname,
                            ssoWindow,
                            $scope.uniqueid
                        );
                    } else {
                        samlTokenService.navigateToken(null, ssoWindow, $scope.uniqueid);
                    }
                };
                $scope.dismiss = function () {
                    $scope.$parent.$close();
                };
            }
        ],
        link: function ($scope, element, attrs) {
            $scope.factoryname = $scope.$eval(attrs.factoryname);
        },
        scope: {
            factoryname: "@",
            uniqueid: "@"
        }
    };
};
SamlDisclaimerDirective.$inject = ["samlTokenService", "$modal"];
export default SamlDisclaimerDirective;
